module.exports = __webpack_public_path__ + "pc/img/body_basic-4.cffc60b5.png";